/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  NodoDto,
  NodoCreateOrUpdateDto,
  AlloggiamentiFiltroUpdateDtoInt32EntityChange,
  FiltroUpdateDtoInt32EntityChange,
  OlioUpdateDtoInt32EntityChange,
  ReminderUpdateDtoInt32EntityChange,
  BonificaUpdateDtoInt32EntityChange,
  AnalisiUpdateDtoInt32EntityChange,
  FiltrazioneUpdateDtoInt32EntityChange,
  ManutenzioneUpdateDtoInt32EntityChange,
  GrafoDto,
  ArcoCreateOrUpdateDtoInt32EntityChange,
} from ".././models";

export const getNodoPortale = (
  portale: 1 | 2 | 3,
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoDto>> => {
  return axios.get(`/api/portali/${portale}/nodi/${id}`, options);
};

export const getGetNodoPortaleQueryKey = (portale: 1 | 2 | 3, id: number) =>
  [`/api/portali/${portale}/nodi/${id}`] as const;

export const getGetNodoPortaleQueryOptions = <
  TData = Awaited<ReturnType<typeof getNodoPortale>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNodoPortale>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getNodoPortale>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNodoPortaleQueryKey(portale, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodoPortale>>> = ({
    signal,
  }) => getNodoPortale(portale, id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(portale && id), ...queryOptions };
};

export type GetNodoPortaleQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNodoPortale>>
>;
export type GetNodoPortaleQueryError = AxiosError<unknown>;

export const useGetNodoPortale = <
  TData = Awaited<ReturnType<typeof getNodoPortale>>,
  TError = AxiosError<unknown>
>(
  portale: 1 | 2 | 3,
  id: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNodoPortale>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNodoPortaleQueryOptions(portale, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getNodo = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoDto>> => {
  return axios.get(`/api/nodi/${id}`, options);
};

export const getGetNodoQueryKey = (id: number) => [`/api/nodi/${id}`] as const;

export const getGetNodoQueryOptions = <
  TData = Awaited<ReturnType<typeof getNodo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNodo>>, TError, TData>;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<Awaited<ReturnType<typeof getNodo>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNodoQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodo>>> = ({
    signal,
  }) => getNodo(id, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!id, ...queryOptions };
};

export type GetNodoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNodo>>
>;
export type GetNodoQueryError = AxiosError<unknown>;

export const useGetNodo = <
  TData = Awaited<ReturnType<typeof getNodo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getNodo>>, TError, TData>;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNodoQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateNodo = (
  id: number,
  nodoCreateOrUpdateDto: NodoCreateOrUpdateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.put(`/api/nodi/${id}`, nodoCreateOrUpdateDto, options);
};

export const getUpdateNodoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNodo>>,
    TError,
    { id: number; data: NodoCreateOrUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateNodo>>,
  TError,
  { id: number; data: NodoCreateOrUpdateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateNodo>>,
    { id: number; data: NodoCreateOrUpdateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateNodo(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateNodoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateNodo>>
>;
export type UpdateNodoMutationBody = NodoCreateOrUpdateDto;
export type UpdateNodoMutationError = AxiosError<unknown>;

export const useUpdateNodo = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateNodo>>,
    TError,
    { id: number; data: NodoCreateOrUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateNodoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const eliminaNodo = (
  id: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.delete(`/api/nodi/${id}`, options);
};

export const getEliminaNodoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eliminaNodo>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof eliminaNodo>>,
  TError,
  { id: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof eliminaNodo>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return eliminaNodo(id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EliminaNodoMutationResult = NonNullable<
  Awaited<ReturnType<typeof eliminaNodo>>
>;

export type EliminaNodoMutationError = AxiosError<unknown>;

export const useEliminaNodo = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof eliminaNodo>>,
    TError,
    { id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getEliminaNodoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getNodoByQRCode = (
  token: string,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoDto>> => {
  return axios.get(`/api/nodi/qrcode/${token}`, options);
};

export const getGetNodoByQRCodeQueryKey = (token: string) =>
  [`/api/nodi/qrcode/${token}`] as const;

export const getGetNodoByQRCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getNodoByQRCode>>,
  TError = AxiosError<unknown>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNodoByQRCode>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof getNodoByQRCode>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNodoByQRCodeQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNodoByQRCode>>> = ({
    signal,
  }) => getNodoByQRCode(token, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!token, ...queryOptions };
};

export type GetNodoByQRCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNodoByQRCode>>
>;
export type GetNodoByQRCodeQueryError = AxiosError<unknown>;

export const useGetNodoByQRCode = <
  TData = Awaited<ReturnType<typeof getNodoByQRCode>>,
  TError = AxiosError<unknown>
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getNodoByQRCode>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetNodoByQRCodeQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateAlloggiamentiFiltro = (
  id: number,
  alloggiamentiFiltroUpdateDtoInt32EntityChange: AlloggiamentiFiltroUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/alloggiamentiFiltro`,
    alloggiamentiFiltroUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateAlloggiamentiFiltroMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAlloggiamentiFiltro>>,
    TError,
    { id: number; data: AlloggiamentiFiltroUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAlloggiamentiFiltro>>,
  TError,
  { id: number; data: AlloggiamentiFiltroUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAlloggiamentiFiltro>>,
    { id: number; data: AlloggiamentiFiltroUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAlloggiamentiFiltro(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAlloggiamentiFiltroMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAlloggiamentiFiltro>>
>;
export type UpdateAlloggiamentiFiltroMutationBody =
  AlloggiamentiFiltroUpdateDtoInt32EntityChange[];
export type UpdateAlloggiamentiFiltroMutationError = AxiosError<unknown>;

export const useUpdateAlloggiamentiFiltro = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAlloggiamentiFiltro>>,
    TError,
    { id: number; data: AlloggiamentiFiltroUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateAlloggiamentiFiltroMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateStoricoFiltri = (
  id: number,
  alloggiamentoFiltroId: number,
  filtroUpdateDtoInt32EntityChange: FiltroUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/alloggiamentiFiltro/${alloggiamentoFiltroId}/storicoFiltri`,
    filtroUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateStoricoFiltriMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStoricoFiltri>>,
    TError,
    {
      id: number;
      alloggiamentoFiltroId: number;
      data: FiltroUpdateDtoInt32EntityChange[];
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStoricoFiltri>>,
  TError,
  {
    id: number;
    alloggiamentoFiltroId: number;
    data: FiltroUpdateDtoInt32EntityChange[];
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStoricoFiltri>>,
    {
      id: number;
      alloggiamentoFiltroId: number;
      data: FiltroUpdateDtoInt32EntityChange[];
    }
  > = (props) => {
    const { id, alloggiamentoFiltroId, data } = props ?? {};

    return updateStoricoFiltri(id, alloggiamentoFiltroId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStoricoFiltriMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStoricoFiltri>>
>;
export type UpdateStoricoFiltriMutationBody =
  FiltroUpdateDtoInt32EntityChange[];
export type UpdateStoricoFiltriMutationError = AxiosError<unknown>;

export const useUpdateStoricoFiltri = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStoricoFiltri>>,
    TError,
    {
      id: number;
      alloggiamentoFiltroId: number;
      data: FiltroUpdateDtoInt32EntityChange[];
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateStoricoFiltriMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateStoricoOlio = (
  id: number,
  olioUpdateDtoInt32EntityChange: OlioUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/storicoOlio`,
    olioUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateStoricoOlioMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStoricoOlio>>,
    TError,
    { id: number; data: OlioUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateStoricoOlio>>,
  TError,
  { id: number; data: OlioUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateStoricoOlio>>,
    { id: number; data: OlioUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateStoricoOlio(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateStoricoOlioMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateStoricoOlio>>
>;
export type UpdateStoricoOlioMutationBody = OlioUpdateDtoInt32EntityChange[];
export type UpdateStoricoOlioMutationError = AxiosError<unknown>;

export const useUpdateStoricoOlio = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateStoricoOlio>>,
    TError,
    { id: number; data: OlioUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateStoricoOlioMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateReminders = (
  id: number,
  reminderUpdateDtoInt32EntityChange: ReminderUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/reminders`,
    reminderUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateRemindersMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReminders>>,
    TError,
    { id: number; data: ReminderUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReminders>>,
  TError,
  { id: number; data: ReminderUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReminders>>,
    { id: number; data: ReminderUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateReminders(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRemindersMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReminders>>
>;
export type UpdateRemindersMutationBody = ReminderUpdateDtoInt32EntityChange[];
export type UpdateRemindersMutationError = AxiosError<unknown>;

export const useUpdateReminders = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReminders>>,
    TError,
    { id: number; data: ReminderUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateRemindersMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateBonifiche = (
  id: number,
  bonificaUpdateDtoInt32EntityChange: BonificaUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/bonifiche`,
    bonificaUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateBonificheMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBonifiche>>,
    TError,
    { id: number; data: BonificaUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateBonifiche>>,
  TError,
  { id: number; data: BonificaUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateBonifiche>>,
    { id: number; data: BonificaUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateBonifiche(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateBonificheMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateBonifiche>>
>;
export type UpdateBonificheMutationBody = BonificaUpdateDtoInt32EntityChange[];
export type UpdateBonificheMutationError = AxiosError<unknown>;

export const useUpdateBonifiche = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateBonifiche>>,
    TError,
    { id: number; data: BonificaUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateBonificheMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateAnalisi = (
  id: number,
  analisiUpdateDtoInt32EntityChange: AnalisiUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/analisi`,
    analisiUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateAnalisiMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnalisi>>,
    TError,
    { id: number; data: AnalisiUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAnalisi>>,
  TError,
  { id: number; data: AnalisiUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAnalisi>>,
    { id: number; data: AnalisiUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateAnalisi(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAnalisiMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAnalisi>>
>;
export type UpdateAnalisiMutationBody = AnalisiUpdateDtoInt32EntityChange[];
export type UpdateAnalisiMutationError = AxiosError<unknown>;

export const useUpdateAnalisi = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAnalisi>>,
    TError,
    { id: number; data: AnalisiUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateAnalisiMutationOptions(options);

  return useMutation(mutationOptions);
};
export const downloadImmagineNodo = (
  id: number,
  idImmagine: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(`/api/nodi/${id}/immagini/${idImmagine}`, options);
};

export const getDownloadImmagineNodoQueryKey = (
  id: number,
  idImmagine: number
) => [`/api/nodi/${id}/immagini/${idImmagine}`] as const;

export const getDownloadImmagineNodoQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadImmagineNodo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idImmagine: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadImmagineNodo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof downloadImmagineNodo>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadImmagineNodoQueryKey(id, idImmagine);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadImmagineNodo>>
  > = ({ signal }) =>
    downloadImmagineNodo(id, idImmagine, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(id && idImmagine), ...queryOptions };
};

export type DownloadImmagineNodoQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadImmagineNodo>>
>;
export type DownloadImmagineNodoQueryError = AxiosError<unknown>;

export const useDownloadImmagineNodo = <
  TData = Awaited<ReturnType<typeof downloadImmagineNodo>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idImmagine: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadImmagineNodo>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDownloadImmagineNodoQueryOptions(
    id,
    idImmagine,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const downloadBonificaImmagine = (
  id: number,
  idBonifica: number,
  idImmagineBonifica: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(
    `/api/nodi/${id}/bonifiche/${idBonifica}/immagine/${idImmagineBonifica}`,
    options
  );
};

export const getDownloadBonificaImmagineQueryKey = (
  id: number,
  idBonifica: number,
  idImmagineBonifica: number
) =>
  [
    `/api/nodi/${id}/bonifiche/${idBonifica}/immagine/${idImmagineBonifica}`,
  ] as const;

export const getDownloadBonificaImmagineQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadBonificaImmagine>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idBonifica: number,
  idImmagineBonifica: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBonificaImmagine>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof downloadBonificaImmagine>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadBonificaImmagineQueryKey(id, idBonifica, idImmagineBonifica);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadBonificaImmagine>>
  > = ({ signal }) =>
    downloadBonificaImmagine(id, idBonifica, idImmagineBonifica, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && idBonifica && idImmagineBonifica),
    ...queryOptions,
  };
};

export type DownloadBonificaImmagineQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadBonificaImmagine>>
>;
export type DownloadBonificaImmagineQueryError = AxiosError<unknown>;

export const useDownloadBonificaImmagine = <
  TData = Awaited<ReturnType<typeof downloadBonificaImmagine>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idBonifica: number,
  idImmagineBonifica: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadBonificaImmagine>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDownloadBonificaImmagineQueryOptions(
    id,
    idBonifica,
    idImmagineBonifica,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const downloadRapportinoBonifica = (
  id: number,
  idBonifica: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(
    `/api/nodi/${id}/bonifiche/${idBonifica}/rapportino`,
    options
  );
};

export const getDownloadRapportinoBonificaQueryKey = (
  id: number,
  idBonifica: number
) => [`/api/nodi/${id}/bonifiche/${idBonifica}/rapportino`] as const;

export const getDownloadRapportinoBonificaQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadRapportinoBonifica>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idBonifica: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadRapportinoBonifica>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof downloadRapportinoBonifica>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadRapportinoBonificaQueryKey(id, idBonifica);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadRapportinoBonifica>>
  > = ({ signal }) =>
    downloadRapportinoBonifica(id, idBonifica, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(id && idBonifica), ...queryOptions };
};

export type DownloadRapportinoBonificaQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadRapportinoBonifica>>
>;
export type DownloadRapportinoBonificaQueryError = AxiosError<unknown>;

export const useDownloadRapportinoBonifica = <
  TData = Awaited<ReturnType<typeof downloadRapportinoBonifica>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idBonifica: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadRapportinoBonifica>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDownloadRapportinoBonificaQueryOptions(
    id,
    idBonifica,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateFiltrazioni = (
  id: number,
  filtrazioneUpdateDtoInt32EntityChange: FiltrazioneUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/filtrazioni`,
    filtrazioneUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateFiltrazioniMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFiltrazioni>>,
    TError,
    { id: number; data: FiltrazioneUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateFiltrazioni>>,
  TError,
  { id: number; data: FiltrazioneUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateFiltrazioni>>,
    { id: number; data: FiltrazioneUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateFiltrazioni(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateFiltrazioniMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateFiltrazioni>>
>;
export type UpdateFiltrazioniMutationBody =
  FiltrazioneUpdateDtoInt32EntityChange[];
export type UpdateFiltrazioniMutationError = AxiosError<unknown>;

export const useUpdateFiltrazioni = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateFiltrazioni>>,
    TError,
    { id: number; data: FiltrazioneUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateFiltrazioniMutationOptions(options);

  return useMutation(mutationOptions);
};
export const downloadRapportinoFiltrazione = (
  id: number,
  idFiltrazione: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(
    `/api/nodi/${id}/filtrazioni/${idFiltrazione}/rapportino`,
    options
  );
};

export const getDownloadRapportinoFiltrazioneQueryKey = (
  id: number,
  idFiltrazione: number
) => [`/api/nodi/${id}/filtrazioni/${idFiltrazione}/rapportino`] as const;

export const getDownloadRapportinoFiltrazioneQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadRapportinoFiltrazione>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idFiltrazione: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadRapportinoFiltrazione>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof downloadRapportinoFiltrazione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadRapportinoFiltrazioneQueryKey(id, idFiltrazione);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadRapportinoFiltrazione>>
  > = ({ signal }) =>
    downloadRapportinoFiltrazione(id, idFiltrazione, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && idFiltrazione),
    ...queryOptions,
  };
};

export type DownloadRapportinoFiltrazioneQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadRapportinoFiltrazione>>
>;
export type DownloadRapportinoFiltrazioneQueryError = AxiosError<unknown>;

export const useDownloadRapportinoFiltrazione = <
  TData = Awaited<ReturnType<typeof downloadRapportinoFiltrazione>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idFiltrazione: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadRapportinoFiltrazione>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDownloadRapportinoFiltrazioneQueryOptions(
    id,
    idFiltrazione,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const downloadPdfAnalisi = (
  id: number,
  idAnalisi: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(`/api/nodi/${id}/analisi/${idAnalisi}/pdf`, options);
};

export const getDownloadPdfAnalisiQueryKey = (id: number, idAnalisi: number) =>
  [`/api/nodi/${id}/analisi/${idAnalisi}/pdf`] as const;

export const getDownloadPdfAnalisiQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadPdfAnalisi>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idAnalisi: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadPdfAnalisi>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof downloadPdfAnalisi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadPdfAnalisiQueryKey(id, idAnalisi);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadPdfAnalisi>>
  > = ({ signal }) =>
    downloadPdfAnalisi(id, idAnalisi, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(id && idAnalisi), ...queryOptions };
};

export type DownloadPdfAnalisiQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadPdfAnalisi>>
>;
export type DownloadPdfAnalisiQueryError = AxiosError<unknown>;

export const useDownloadPdfAnalisi = <
  TData = Awaited<ReturnType<typeof downloadPdfAnalisi>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idAnalisi: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadPdfAnalisi>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDownloadPdfAnalisiQueryOptions(
    id,
    idAnalisi,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const updateManutenzioni = (
  id: number,
  manutenzioneUpdateDtoInt32EntityChange: ManutenzioneUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/nodi/${id}/manutenzioni`,
    manutenzioneUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateManutenzioniMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateManutenzioni>>,
    TError,
    { id: number; data: ManutenzioneUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateManutenzioni>>,
  TError,
  { id: number; data: ManutenzioneUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateManutenzioni>>,
    { id: number; data: ManutenzioneUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateManutenzioni(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateManutenzioniMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateManutenzioni>>
>;
export type UpdateManutenzioniMutationBody =
  ManutenzioneUpdateDtoInt32EntityChange[];
export type UpdateManutenzioniMutationError = AxiosError<unknown>;

export const useUpdateManutenzioni = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateManutenzioni>>,
    TError,
    { id: number; data: ManutenzioneUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateManutenzioniMutationOptions(options);

  return useMutation(mutationOptions);
};
export const downloadRapportinoManutenzione = (
  id: number,
  idManutenzione: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.get(
    `/api/nodi/${id}/manutenzioni/${idManutenzione}/rapportino`,
    options
  );
};

export const getDownloadRapportinoManutenzioneQueryKey = (
  id: number,
  idManutenzione: number
) => [`/api/nodi/${id}/manutenzioni/${idManutenzione}/rapportino`] as const;

export const getDownloadRapportinoManutenzioneQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadRapportinoManutenzione>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idManutenzione: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadRapportinoManutenzione>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryOptions<
  Awaited<ReturnType<typeof downloadRapportinoManutenzione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadRapportinoManutenzioneQueryKey(id, idManutenzione);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadRapportinoManutenzione>>
  > = ({ signal }) =>
    downloadRapportinoManutenzione(id, idManutenzione, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && idManutenzione),
    ...queryOptions,
  };
};

export type DownloadRapportinoManutenzioneQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadRapportinoManutenzione>>
>;
export type DownloadRapportinoManutenzioneQueryError = AxiosError<unknown>;

export const useDownloadRapportinoManutenzione = <
  TData = Awaited<ReturnType<typeof downloadRapportinoManutenzione>>,
  TError = AxiosError<unknown>
>(
  id: number,
  idManutenzione: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadRapportinoManutenzione>>,
      TError,
      TData
    >;
    axios?: AxiosRequestConfig;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getDownloadRapportinoManutenzioneQueryOptions(
    id,
    idManutenzione,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const createNodo = (
  nodoCreateOrUpdateDto: NodoCreateOrUpdateDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<NodoDto>> => {
  return axios.post(`/api/nodi`, nodoCreateOrUpdateDto, options);
};

export const getCreateNodoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNodo>>,
    TError,
    { data: NodoCreateOrUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createNodo>>,
  TError,
  { data: NodoCreateOrUpdateDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createNodo>>,
    { data: NodoCreateOrUpdateDto }
  > = (props) => {
    const { data } = props ?? {};

    return createNodo(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateNodoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createNodo>>
>;
export type CreateNodoMutationBody = NodoCreateOrUpdateDto;
export type CreateNodoMutationError = AxiosError<unknown>;

export const useCreateNodo = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createNodo>>,
    TError,
    { data: NodoCreateOrUpdateDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getCreateNodoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const updateTrasferimenti = (
  id: number,
  arcoCreateOrUpdateDtoInt32EntityChange: ArcoCreateOrUpdateDtoInt32EntityChange[],
  options?: AxiosRequestConfig
): Promise<AxiosResponse<GrafoDto>> => {
  return axios.post(
    `/api/nodi/${id}/trasferimenti`,
    arcoCreateOrUpdateDtoInt32EntityChange,
    options
  );
};

export const getUpdateTrasferimentiMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrasferimenti>>,
    TError,
    { id: number; data: ArcoCreateOrUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTrasferimenti>>,
  TError,
  { id: number; data: ArcoCreateOrUpdateDtoInt32EntityChange[] },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTrasferimenti>>,
    { id: number; data: ArcoCreateOrUpdateDtoInt32EntityChange[] }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTrasferimenti(id, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTrasferimentiMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTrasferimenti>>
>;
export type UpdateTrasferimentiMutationBody =
  ArcoCreateOrUpdateDtoInt32EntityChange[];
export type UpdateTrasferimentiMutationError = AxiosError<unknown>;

export const useUpdateTrasferimenti = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTrasferimenti>>,
    TError,
    { id: number; data: ArcoCreateOrUpdateDtoInt32EntityChange[] },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getUpdateTrasferimentiMutationOptions(options);

  return useMutation(mutationOptions);
};

export const __$$useGetNodoPortale = () =>
  //@ts-ignore
  useGetNodoPortale(...([] as any[]));

export const __$$useGetNodo = () =>
  //@ts-ignore
  useGetNodo(...([] as any[]));

export const __$$useUpdateNodo = () =>
  //@ts-ignore
  useUpdateNodo(...([] as any[]));

export const __$$useEliminaNodo = () =>
  //@ts-ignore
  useEliminaNodo(...([] as any[]));

export const __$$useGetNodoByQRCode = () =>
  //@ts-ignore
  useGetNodoByQRCode(...([] as any[]));

export const __$$useUpdateAlloggiamentiFiltro = () =>
  //@ts-ignore
  useUpdateAlloggiamentiFiltro(...([] as any[]));

export const __$$useUpdateStoricoFiltri = () =>
  //@ts-ignore
  useUpdateStoricoFiltri(...([] as any[]));

export const __$$useUpdateStoricoOlio = () =>
  //@ts-ignore
  useUpdateStoricoOlio(...([] as any[]));

export const __$$useUpdateReminders = () =>
  //@ts-ignore
  useUpdateReminders(...([] as any[]));

export const __$$useUpdateBonifiche = () =>
  //@ts-ignore
  useUpdateBonifiche(...([] as any[]));

export const __$$useUpdateAnalisi = () =>
  //@ts-ignore
  useUpdateAnalisi(...([] as any[]));

export const __$$useDownloadImmagineNodo = () =>
  //@ts-ignore
  useDownloadImmagineNodo(...([] as any[]));

export const __$$useDownloadBonificaImmagine = () =>
  //@ts-ignore
  useDownloadBonificaImmagine(...([] as any[]));

export const __$$useDownloadRapportinoBonifica = () =>
  //@ts-ignore
  useDownloadRapportinoBonifica(...([] as any[]));

export const __$$useUpdateFiltrazioni = () =>
  //@ts-ignore
  useUpdateFiltrazioni(...([] as any[]));

export const __$$useDownloadRapportinoFiltrazione = () =>
  //@ts-ignore
  useDownloadRapportinoFiltrazione(...([] as any[]));

export const __$$useDownloadPdfAnalisi = () =>
  //@ts-ignore
  useDownloadPdfAnalisi(...([] as any[]));

export const __$$useUpdateManutenzioni = () =>
  //@ts-ignore
  useUpdateManutenzioni(...([] as any[]));

export const __$$useDownloadRapportinoManutenzione = () =>
  //@ts-ignore
  useDownloadRapportinoManutenzione(...([] as any[]));

export const __$$useCreateNodo = () =>
  //@ts-ignore
  useCreateNodo(...([] as any[]));

export const __$$useUpdateTrasferimenti = () =>
  //@ts-ignore
  useUpdateTrasferimenti(...([] as any[]));
